import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { AdminDashboardContainer } from "../../style/Admin/AdminDashboard.jsx";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import "../../style/theme/index.js";
import { Doughnut, Line, Bar } from "react-chartjs-2";
import { fetchDonutDetails } from "../../services/adminDashboardServices.js";
import DashboardHeader from "../../components/Common/DashboardHeader";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Tooltip,
  Legend
);

const AdminDashboard = () => {
  const [coursesDetails, setCoursesDetails] = useState({
    labels: [],
    datasets: [],
  });
  const [categoriesVsCoursesData, setCategoriesVsCoursesData] = useState({
    labels: [],
    datasets: [],
  });

  const fetchChartData = async () => {
    try {
      const response = await fetchDonutDetails();
      if (response?.success) {
        const { statusWiseCourses, categoryWiseCoursesCount } = response.data;

        setCoursesDetails({
          labels: statusWiseCourses.labels || [],
          datasets: [
            {
              label: "Courses",
              data: statusWiseCourses.data || [],

              backgroundColor: ["#4caf50", "#ffeb3b", "#f44336"],

              hoverOffset: 10,
            },
          ],
        });

        setCategoriesVsCoursesData({
          labels: categoryWiseCoursesCount.labels,
          datasets: [
            {
              label: "Number of Courses",
              data: categoryWiseCoursesCount.data,
              backgroundColor: "#4caf50",
            },
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    fetchChartData();
  }, []);

  return (
    <AdminDashboardContainer>
      <DashboardHeader title="Admin Dashboard" />

      <Container maxWidth="xl" className="dashboard-container">
        <Typography className="title_card" variant="h4" gutterBottom>
          Courses Overview
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card className="dashboard-card">
              <CardContent>
                <Typography className="title_card" variant="h6" gutterBottom>
                  Courses Details
                </Typography>
                <Box className="chart-box">
                  <Doughnut data={coursesDetails} />
                </Box>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card className="dashboard-card">
              <CardContent>
                <Typography className="title_card" variant="h6" gutterBottom>
                  Categories vs Courses
                </Typography>
                <Box className="chart-box">
                  <Bar
                    data={categoriesVsCoursesData}
                    height={300}
                    width={600}
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      scales: {
                        x: {
                          ticks: { font: { size: 14 } },
                        },
                        y: {
                          ticks: { font: { size: 14 } },
                        },
                      },
                      plugins: {
                        legend: { labels: { font: { size: 14 } } },
                      },
                    }}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </AdminDashboardContainer>
  );
};

export default AdminDashboard;
